import React, { Fragment } from "react";
import { connect } from "react-redux";
import { reduxForm, change as inputChange, formValueSelector, Field } from "redux-form";

import { getEnabledFeatures, getRequireDonationAddress } from "data/entity";

import { getCampaign } from "data/parent-campaign";

import { getSpreedlyErrors } from "data/spreedly";

import { getBillingType, setIsStripeSepaDebit } from "data/giving-form/billing";

import donateFormValidation, {
  emailValidation,
  presenceValidation,
  presenceCollectionValidation,
  lengthValidation,
  safeDisplayName,
} from "lib/utils/donation-form-validation";

import monthOptions from "lib/utils/month-options";
import {
  getAllocationType,
  getSelectedAllocations,
  getConnectedStripeAccountId,
  getStripePublishableKey,
} from "data/giving-form/allocation-selection";

import { logout, getUser } from "data/user";

import SpreedlyForm from "../../../../shared/components/spreedly-form";
import CustomFields from "../../../../shared/components/custom-fields";

import Address from "lib/components/Address";
import InputField from "lib/components/InputField";
import Select from "lib/components/Select";
import MultiSelect from "lib/components/MultiSelectReduxForm";
import FormattedNumberInput from "lib/components/FormattedNumberInput";
import DisplayError from "lib/components/DisplayError";

import { Elements } from "@stripe/react-stripe-js";
import CheckoutStripeForm from "../../../components/stripe-form/CheckoutStripeFrom";
import { loadStripe } from "@stripe/stripe-js";
import { FormattedMessage } from "react-intl";
import Braintree from "../../braintree/Braintree";
import customFieldsAPI from "../../../../shared/api/giving-form-api/customFieldsAPI";
import { fromJS } from "immutable";
import { bindActionCreators } from "redux";

class DisplayNameInput extends React.Component {
  render() {
    const { input, meta, placeholder, type, disabled } = this.props;
    const cursorCss = { cursor: disabled ? "not-allowed" : "text" };

    return (
      <div className="p-sm-b">
        <input
          data-testid="t-giving-form--DonateF-input"
          style={cursorCss}
          disabled={disabled}
          placeholder={placeholder}
          type={type}
          name={input.name}
          value={input.value}
          onChange={input.onChange}
        />
        {meta.invalid && <span className="donation-error">{meta.error}</span>}
      </div>
    );
  }
}
class DonateForm extends React.Component {
  state = {
    loading: false,
    isPublic: true,
    stripeCreditCard: true,
    digitalWalletMode: false,
    sepaDirectDebitMode: false,
    customFields: [],
  };

  componentDidMount() {
    this.setDefaultCountry();
    this.fetchCustomFields();
  }

  componentDidUpdate() {
    const { isFormValid } = this.props;
    const { digitalWalletMode } = this.state;
    if (digitalWalletMode) {
      isFormValid(true);
    }
  }

  async fetchCustomFields() {
    const { selectedAllocations, parentCampaign, allocationType } = this.props;
    const ids =
      selectedAllocations.size > 0 && allocationType == "campaign"
        ? selectedAllocations.map((a) => a.get("id"))
        : [parentCampaign.get("id")];
    const response = await customFieldsAPI.fetchCustomFieldsByCampaigns({
      campaign_ids: ids,
    });
    if (!response) return;

    const { entity_custom_fields } = response;
    this.setState({
      customFields: fromJS(entity_custom_fields),
    });
  }

  setDefaultCountry = () => {
    const { dispatch, defaultCountry } = this.props;

    if (defaultCountry) {
      dispatch(inputChange("donation", "address.country", defaultCountry));
    }
  };

  getSpreedlyKey = () => {
    const { parentCampaign, allocationType, selectedAllocations } = this.props;

    if (allocationType == "campaign" && selectedAllocations.count() > 0) {
      return selectedAllocations.first().get("spreedly_key");
    }

    return parentCampaign.get("spreedly_key");
  };

  handleLogout = (e) => {
    const { logout } = this.props;

    e.preventDefault();

    this.setState({
      loading: true,
    });

    logout().then(() => {
      this.setState({
        loading: false,
      });
    });
  };

  renderMonthOptions() {
    return [
      <option key="month" value="month" disabled={true}>
        Month
      </option>,
    ].concat(monthOptions);
  }

  renderYearOptions() {
    const options = [];

    const currentYear = new Date().getFullYear();

    const currentYearDigits = parseInt(currentYear.toString().slice(-2));

    for (let i = currentYearDigits; i <= currentYearDigits + 15; i++) {
      options.push(<option key={i} value={i}>{`20${i}`}</option>);
    }

    return [
      <option key="year" value="year" disabled={true}>
        Year
      </option>,
    ].concat(options);
  }

  renderDisplayNameOptions() {
    const options = [];

    options.push(
      <option key="public" value="public">
        Public
      </option>,
    );
    options.push(
      <option key="anonymous" value="anonymous">
        Anonymous
      </option>,
    );
    options.push(
      <option key="alias" value="alias">
        With an alias
      </option>,
    );
    options.push(
      <option key="honor" value="honor">
        In Honor Of
      </option>,
    );

    return options;
  }

  renderDonorCommentField() {
    const { donorCommentsEnabled } = this.props;
    if (donorCommentsEnabled) {
      return (
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <label>
              <FormattedMessage id="comment" />
            </label>
            <Field
              name="comment"
              aria-label="Comment"
              type="text"
              onChange={this.setComment.bind(this)}
              component={InputField}
            />
          </div>
        </div>
      );
    }
  }

  renderDisplayNameFields() {
    const { donationInHonorOfEnabled } = this.props;

    if (donationInHonorOfEnabled) {
      return (
        <div>
          <div className="clearfix custom-fields">
            <p className="description col-md-12">
              <FormattedMessage id="donorDisplay" />
            </p>
          </div>
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <label>
                <FormattedMessage id="displayType" />
              </label>
              <Field
                onChange={this.changeDisplayType.bind(this)}
                aria-label="Display Type"
                className="p-sm-b"
                name="display_type"
                component={Select}
                children={this.renderDisplayNameOptions()}
              />
            </div>
            <div className="col-xs-12 col-md-6">
              <label>
                <FormattedMessage id="displayName" />
              </label>
              <Field
                name="display_name"
                aria-label="Display Name"
                type="text"
                disabled={
                  this.props.display_type != "alias" && this.props.display_type != "honor"
                }
                onChange={this.setDisplayName.bind(this)}
                placeholder={this.displayNamePlaceholder()}
                component={DisplayNameInput}
                validate={[safeDisplayName]}
              />
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="clearfix custom-fields">
          <p className="description col-md-12">
            <FormattedMessage id="donorDisplay" />
          </p>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <label>
              <FormattedMessage id="donorNameDisplay" />
            </label>
            <br />
            <Field
              aria-label="Display my name as a donor field"
              className="p-sm-b"
              name="isPublic"
              onChange={this.setPublic.bind(this)}
              component="input"
              type="checkbox"
            />
          </div>
          <div className="col-xs-12 col-md-6">
            <label>Display Name</label>
            <Field
              name="display_name"
              type="text"
              disabled={!this.state.isPublic}
              onChange={this.setDisplayName.bind(this)}
              placeholder={this.state.isPublic ? "" : "Anonymous"}
              component={DisplayNameInput}
              validate={[safeDisplayName]}
            />
          </div>
        </div>
      </div>
    );
  }

  renderCurrentUser() {
    const { currentUser } = this.props;
    const { loading } = this.state;

    if (loading) {
      return (
        <div className="text-center">
          <i className="fa fa-2x fa-refresh fa-spin" />
        </div>
      );
    }
    if (currentUser) {
      return (
        <div className="p-sm-b p-xs-t">
          <b>
            <FormattedMessage id="loggedInAs" />{" "}
            {`${currentUser.get("first_name")} ${currentUser.get("last_name")}`} <br />
            <FormattedMessage id="toChangeDonorPlease" />
            <a
              data-testid="t-giving-form--DonateF-a-2"
              className="pointer"
              onClick={this.handleLogout}>
              {" "}
              <FormattedMessage id="useDifferentEmail" />
            </a>
            .
          </b>
        </div>
      );
    }

    return (
      <div>
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <label className="required-field" htmlFor="donating_first_name">
              <FormattedMessage id="firstName" />
            </label>
            <Field
              aria-label="First Name"
              name="first_name"
              component={InputField}
              className="p-sm-b"
              validate={[presenceValidation, lengthValidation(25)]}
              type="text"
            />
          </div>

          <div className="col-xs-12 col-sm-6">
            <label className="required-field" htmlFor="donating_last_name">
              <FormattedMessage id="lastName" />
            </label>
            <Field
              aria-label="Last Name"
              name="last_name"
              component={InputField}
              className="p-sm-b"
              validate={[presenceValidation, lengthValidation(25)]}
              type="text"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <label className="required-field" htmlFor="email">
              <FormattedMessage id="email" />
            </label>
            <Field
              aria-label="Email"
              name="email"
              component={InputField}
              className="p-sm-b"
              validate={[emailValidation]}
              type="text"
            />
          </div>
        </div>
      </div>
    );
  }
  changeDisplayType(e, display_type) {
    const { dispatch } = this.props;

    if (display_type != "alias" && display_type != "honor") {
      dispatch(inputChange("donation", "display_name", null));
    }
  }
  setPublic(e, isPublic) {
    const { dispatch } = this.props;
    this.setState({ isPublic });

    if (!isPublic) {
      const { dispatch } = this.props;
      dispatch(inputChange("donation", "display_name", null));
      dispatch(inputChange("donation", "display_type", "anonymous"));
    } else {
      dispatch(inputChange("donation", "display_type", null));
    }
  }
  setDisplayName(e, display_name) {
    const { dispatch, display_type } = this.props;
    this.setState({ display_name });
    if (display_name.match(/^\s*$/)) {
      dispatch(inputChange("donation", "display_type", null));
    } else if (display_type !== "honor" && display_type !== "alias") {
      dispatch(inputChange("donation", "display_type", "alias"));
    }
  }

  setComment(e, comment) {
    const { dispatch } = this.props;
    this.setState({ comment });
    dispatch(inputChange("donation", "comment", comment));
  }

  displayNamePlaceholder() {
    const { display_type } = this.props;

    switch (display_type) {
      case "anonymous":
        return "Anonymous";
      case "alias":
        return "Alias";
      case "honor":
        return "In Honor Of";
      default:
        return this.publicDisplayName();
    }
  }
  publicDisplayName() {
    const first_name_input = $('.donation-form input[name="first_name"]')[0];
    const last_name_input = $('.donation-form input[name="last_name"]')[0];

    if (!!first_name_input && !!last_name_input) {
      const full_name = `${first_name_input.value} ${last_name_input.value}`;
      return !full_name.match(/^\s*$/) ? full_name : "Your Name";
    }
    return "Your Name";
  }

  setStripeFormMode = (event) => {
    const { dispatch } = this.props;
    const isSepaDebit = event.target.value === "sepa-direct-debit";
    this.setState({
      stripeCreditCard: event.target.value === "credit-card",
      digitalWalletMode: event.target.value === "digital-wallet",
      sepaDirectDebitMode: isSepaDebit,
    });
    dispatch(setIsStripeSepaDebit(isSepaDebit));
  };

  render() {
    const {
      invalid,
      countries,
      billingType,
      donationInHonorOfEnabled,
      requireAddress,
      first_name,
      last_name,
      month,
      year,
      address,
      city,
      region,
      zip,
      country,
      cell_phone,
      submitForm,
      stopValidation,
      emptyMonthError,
      expiredYearError,
      parentCampaign,
      isFormValid,
      isStripePayment,
      isStripeUkSepaDebit,
      connectedStripeAccountId,
      stripePublishableKey,
      customSubmit,
      handleCreateStripeCustomer,
      isBbmsPayment,
      isBraintreePayment,
      isSpreedlyPayment,
      createStripeIntent,
      braintreeDropin,
      donorCommentsEnabled,
      hasBraintreeError,
    } = this.props;

    const { stripeCreditCard, digitalWalletMode, sepaDirectDebitMode, customFields } =
      this.state;

    isFormValid(invalid);

    const stripePromise = isStripePayment
      ? loadStripe(stripePublishableKey, {
          stripeAccount: `${connectedStripeAccountId}`,
        })
      : null;

    return (
      <div>
        <form data-testid="t-giving-form--DonateF-form-3" className="donation-form">
          {isStripePayment && (
            <div className="align-center" onChange={this.setStripeFormMode}>
              <input
                data-testid="t-giving-form--DonateF-stripe-form-mode"
                checked={stripeCreditCard}
                className="stripe-form-mode"
                type="radio"
                value="credit-card"
                name="stripe-form-mode"
              />{" "}
              <FormattedMessage id="creditCard" />
              <input
                data-testid="t-giving-form--DonateF-stripe-form-mode"
                checked={digitalWalletMode}
                className="stripe-form-mode"
                type="radio"
                value="digital-wallet"
                name="stripe-form-mode"
              />{" "}
              <FormattedMessage id="googlePayApplePay" />
              {isStripeUkSepaDebit && (
                <Fragment>
                  <input
                    data-testid="t-giving-form--DonateF-stripe-form-mode"
                    checked={sepaDirectDebitMode}
                    className="stripe-form-mode"
                    type="radio"
                    value="sepa-direct-debit"
                    name="stripe-form-mode"
                  />{" "}
                  <FormattedMessage id="sepaDirectDebit" />
                </Fragment>
              )}
            </div>
          )}
          <div className="voting-modal-body-inside">
            <div>
              <fieldset>
                {!digitalWalletMode && this.renderCurrentUser()}
                {isStripePayment && !isBbmsPayment && (
                  <div>
                    {digitalWalletMode && (
                      <React.Fragment>
                        <div className="clearfix custom-fields">
                          <CustomFields
                            customFields={customFields}
                            wrapperClassName={"col-xs-12 col-md-6"}
                            checkStepNumber={(number) => number == -1}
                          />
                        </div>
                        <div className="clearfix custom-fields">
                          {customFields.size > 0 ? (
                            <p className="description">
                              <FormattedMessage id="additionalDetails" />
                            </p>
                          ) : (
                            ""
                          )}
                          <CustomFields
                            customFields={customFields}
                            wrapperClassName={"row"}
                            checkStepNumber={(number) => number == 0 || number == 1}
                          />
                        </div>
                        <div className="row"></div>
                      </React.Fragment>
                    )}
                    {(stripeCreditCard || digitalWalletMode) && (
                      <Elements stripe={stripePromise}>
                        <CheckoutStripeForm
                          submitPaymentRequest={customSubmit}
                          handleCreateStripeCustomer={handleCreateStripeCustomer}
                          afterFailedStripeValidation={stopValidation}
                          isFormInvalid={invalid}
                          digitalWalletMode={digitalWalletMode}
                          createStripeIntent={createStripeIntent}
                        />
                      </Elements>
                    )}
                  </div>
                )}
                {!digitalWalletMode && (
                  <div>
                    {billingType != "payroll deduction" && (
                      <div>
                        {isSpreedlyPayment && (
                          <SpreedlyForm
                            spreedlyKey={this.getSpreedlyKey()}
                            afterSpreedlyValidation={submitForm}
                            afterFailedSpreedlyValidation={stopValidation}
                            useLocale
                            first_name={first_name}
                            last_name={last_name}
                            month={month}
                            year={year}
                            address={address}
                            city={city}
                            region={region}
                            zip={zip}
                            country={country}
                            phone={cell_phone}
                          />
                        )}
                        {isSpreedlyPayment && (
                          <div className="row">
                            <div className="col-xs-12">
                              <label htmlFor="donating_exp" className="required-field">
                                <FormattedMessage id="expirationDate" />
                              </label>
                            </div>
                          </div>
                        )}
                        {isSpreedlyPayment && (
                          <div className="row">
                            <div className="col-xs-12 col-md-12 m-sm-b">
                              <Field
                                aria-label="Expiration Date"
                                name="card_exp"
                                placeholder="MM/YY"
                                fieldFormat="##/##"
                                fieldMask={["M", "M", "Y", "Y"]}
                                validate={[presenceValidation]}
                                component={FormattedNumberInput}
                              />
                              <DisplayError
                                error={[expiredYearError, emptyMonthError]}
                                className="donation-error"
                              />
                            </div>
                          </div>
                        )}
                        {isBraintreePayment && !braintreeDropin && !hasBraintreeError && (
                          <div className="flex-it justify-center">
                            <i className="fa fa-2x fa-refresh fa-spin" />
                          </div>
                        )}
                        {isBraintreePayment && (
                          <Braintree braintreeDropin={braintreeDropin} />
                        )}
                      </div>
                    )}
                    <div className="clearfix">
                      <Address
                        translateLocales
                        showRequired={requireAddress}
                        country={country}
                        countries={countries}
                      />
                    </div>
                    <div className="clearfix custom-fields">
                      <CustomFields
                        customFields={customFields}
                        wrapperClassName={"col-xs-12 col-md-6"}
                        checkStepNumber={(number) => number == -1}
                      />
                    </div>
                    <div className="clearfix custom-fields">
                      {customFields.size > 0 ? (
                        <p className="description">
                          <FormattedMessage id="additionalDetails" />
                        </p>
                      ) : (
                        ""
                      )}
                      <CustomFields
                        customFields={customFields}
                        wrapperClassName={"row"}
                        checkStepNumber={(number) => number == 0 || number == 1}
                      />
                    </div>
                    <div className="row"></div>
                  </div>
                )}
                {this.renderDisplayNameFields()}
                {this.renderDonorCommentField()}
              </fieldset>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

DonateForm = reduxForm({
  form: "donation",
  amount: "1.00",
  validate: donateFormValidation,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(DonateForm);

const mapStateToProps = (state) => {
  const user = getUser(state);

  let first_name, last_name, month, year;

  if (user) {
    first_name = user.get("first_name") || "";
    last_name = user.get("last_name") || "";
  } else {
    first_name = formValueSelector("donation")(state, "first_name");
    last_name = formValueSelector("donation")(state, "last_name");
  }

  if (formValueSelector("donation")(state, "card_exp")) {
    [month, year] = formValueSelector("donation")(state, "card_exp").split("/");
  }

  const isBbmsPayment = getEnabledFeatures(state).includes("bbms_payment");
  const isBraintreePayment = getEnabledFeatures(state).includes("braintree_payment");
  const isStripePayment = getEnabledFeatures(state).includes("stripe");

  return {
    first_name,
    last_name,
    month,
    year,
    address: formValueSelector("donation")(state, "address.address1"),
    address2: formValueSelector("donation")(state, "address.address2"),
    billingType: getBillingType(state),
    city: formValueSelector("donation")(state, "address.city"),
    region: formValueSelector("donation")(state, "address.region"),
    zip: formValueSelector("donation")(state, "address.zip"),
    country: formValueSelector("donation")(state, "address.country"),
    cell_phone: formValueSelector("donation")(state, "address.cell_phone"),
    display_type: formValueSelector("donation")(state, "display_type"),
    display_name: formValueSelector("donation")(state, "display_name"),
    comment: formValueSelector("donation")(state, "comment"),

    currentUser: user,
    donationInHonorOfEnabled: getEnabledFeatures(state).includes("donation_in_honor_of"),
    donorCommentsEnabled: getEnabledFeatures(state).includes("donation_wall_comments"),
    isStripePayment: getEnabledFeatures(state).includes("stripe"),
    isStripeUkSepaDebit: getEnabledFeatures(state).includes("stripe_uk_sepa_debit"),

    parentCampaign: getCampaign(state)("giving_form"),

    requireAddress: getRequireDonationAddress(state),
    expiredYearError: getSpreedlyErrors(state).get("year"),
    emptyMonthError: getSpreedlyErrors(state).get("month"),
    allocationType: getAllocationType(state),
    selectedAllocations: getSelectedAllocations(state),
    connectedStripeAccountId: getConnectedStripeAccountId(state),
    stripePublishableKey: getStripePublishableKey(state),
    isBbmsPayment: isBbmsPayment,
    isBraintreePayment: isBraintreePayment,
    isStripePayment: isStripePayment,
    isSpreedlyPayment: !isBbmsPayment && !isBraintreePayment && !isStripePayment,
  };
};

const mapActionCreators = (dispatch) => {
  return {
    dispatch,
    ...bindActionCreators(
      {
        logout,
        setIsStripeSepaDebit,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapActionCreators)(DonateForm);
